<template>
  <div class="usage-page">
    <!-- 面包屑：名称与菜单配置同步 -->
    <AppBreadcrumb :items="[{ path: 'usageStatistics' }]" />

    <div class="page-body">
      <div class="page-head">
        <div>
          <!-- <h1>用量统计</h1> -->
          <p>按天或按月查询各水表的用量情况。</p>
        </div>
      </div>

      <!-- 筛选 -->
      <el-card class="filter-card" shadow="never">
        <el-form :model="query" label-position="top" size="small" class="filter-form">
          <el-row :gutter="12">
            <!-- <el-col :xs="24" :sm="12" :md="6" :lg="4">
              <el-form-item label="当前项目">
                <el-input :value="projectName" disabled />
              </el-form-item>
            </el-col> -->
            <el-col :xs="24" :sm="12" :md="6" :lg="4">
              <el-form-item label="水表编号">
                <el-input v-model.trim="query.meter_id" clearable placeholder="请输入水表编号" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="4">
              <el-form-item label="用户名称">
                <el-input v-model.trim="query.username" clearable placeholder="请输入用户名称" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="5">
              <el-form-item label="查看方式">
                <div class="period-switch">
                  <button
                    type="button"
                    :class="{ active: query.period_type === 'day' }"
                    @click="switchPeriod('day')"
                  >按天查看</button>
                  <button
                    type="button"
                    :class="{ active: query.period_type === 'month' }"
                    @click="switchPeriod('month')"
                  >按月查看</button>
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="7">
              <el-form-item :label="query.period_type === 'day' ? '日期范围' : '月份范围'">
                <el-date-picker
                  v-if="query.period_type === 'day'"
                  v-model="dayRange"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 100%"
                  :picker-options="dayPickerOptions"
                />
                <el-date-picker
                  v-else
                  v-model="monthRange"
                  type="monthrange"
                  value-format="yyyy-MM"
                  range-separator="至"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份"
                  style="width: 100%"
                  :picker-options="monthPickerOptions"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="12">
            <el-col :xs="12" :sm="8" :md="4" :lg="3">
              <el-form-item label="小区">
                <el-select v-model="query.community_id" clearable placeholder="全部" style="width:100%" @change="onCommunityChange">
                  <el-option v-for="item in communities" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="8" :md="4" :lg="3">
              <el-form-item label="楼栋">
                <el-select v-model="query.building_id" clearable placeholder="全部" style="width:100%" @change="onBuildingChange">
                  <el-option v-for="item in buildings" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="8" :md="4" :lg="3">
              <el-form-item label="单元">
                <el-select v-model="query.unit_id" clearable placeholder="全部" style="width:100%" @change="onUnitChange">
                  <el-option v-for="item in units" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="8" :md="4" :lg="3">
              <el-form-item label="房号">
                <el-select v-model="query.room_id" clearable placeholder="全部" style="width:100%">
                  <el-option v-for="item in rooms" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="8" :md="6" :lg="3">
              <el-form-item label="数据情况">
                <el-select v-model="query.data_status" style="width:100%">
                  <el-option v-for="item in dataStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="8" :md="6" :lg="3">
              <el-form-item :label="freezeStatusLabel">
                <el-select v-model="query.freeze_status" style="width:100%">
                  <el-option v-for="item in freezeStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="8" :md="4" :lg="2">
              <el-form-item label="每页数量">
                <el-select v-model="query.pagesize" style="width:100%">
                  <el-option :value="10" label="10" />
                  <el-option :value="30" label="30" />
                  <el-option :value="50" label="50" />
                  <el-option :value="100" label="100" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="10" :lg="4">
              <el-form-item label="  ">
                <div class="filter-actions">
                  <el-button type="primary" style="border-color: #6f4cff; background-color: #6f4cff; color: #fff;" size="small" :loading="loading" @click="handleQuery">查询</el-button>
                  <el-button size="small" @click="handleReset">重置</el-button>
                  <el-button size="small" :loading="exporting" @click="handleExport">导出</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>

      <!-- 表格 -->
      <el-card class="table-card" shadow="never">
        <div slot="header" class="table-head">
          <span class="table-title">水表用量一览</span>
          <span class="meta">当前显示：{{ query.period_type === 'day' ? '按天查看' : '按月查看' }}</span>
        </div>

        <el-table
          v-loading="loading"
          :data="tableData"
          size="mini"
          border
          :header-cell-style="headerCellStyle"
          empty-text="暂无符合条件的数据"
          style="width: 100%"
          :max-height="tableMaxHeight"
        >
          <el-table-column label="水表编号" min-width="140" fixed>
            <template slot-scope="{ row }">
              <div class="meter-cell" @click="openDrawer(row)">
                <strong class="meter-link">{{ row.meter_id }}</strong>
                <span class="meter-tip">点击查看明细</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="username" label="用户名称" min-width="120" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.username || '—' }}</template>
          </el-table-column>
          <el-table-column label="位置" min-width="180" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ formatLocation(row.location) }}</template>
          </el-table-column>
          <el-table-column :label="freezeStatusLabel" min-width="120" align="center">
            <template slot-scope="{ row }">
              <span class="tag" :class="freezeTagClass(row)">{{ freezeTagText(row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="数据情况" min-width="110" align="center">
            <template slot-scope="{ row }">
              <span class="tag" :class="row.report_status">{{ stateLabels[row.report_status] || row.report_status || '—' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="已统计用量" min-width="110" align="center">
            <template slot-scope="{ row }">
              <span class="known-sum">{{ sumKnown(row) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="label in periodLabels"
            :key="label"
            :label="label"
            min-width="110"
            align="center"
          >
            <template slot-scope="{ row }">
              <div class="period-cell" :class="{ missing: getPeriodRecord(row, label).flow == null }">
                <span class="flow">{{ formatFlow(getPeriodRecord(row, label).flow) }}</span>
                <span class="sub">{{ getPeriodRecord(row, label).display_status || '—' }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="table-footer">
          <div class="footnote">ⓘ “—”表示该时段暂无数据，不代表用量为 0。</div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="query.pagenum"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="query.pagesize"
            layout="total, sizes, prev, pager, next"
            :total="total"
          />
        </div>
      </el-card>

      <!-- 说明 -->
      <el-card class="note-card" shadow="never">
        <div slot="header"><span class="table-title">说明</span></div>
        <p>1. 本页面用量由日冻结数据或月冻结数据计算得出。</p>
        <p>2. 本页面统计口径与结账、收费、账单中的结算用量口径不同，仅用于查询和分析，不作为结账依据。</p>
        <p>3. 表格中的“—”表示该时段暂无数据，不代表用量为 0。</p>
      </el-card>
    </div>

    <!-- 明细抽屉 -->
    <el-drawer
      :title="drawerTitle"
      :visible.sync="drawerVisible"
      direction="rtl"
      :size="drawerSize"
      custom-class="usage-drawer"
    >
      <div v-if="currentDevice" class="drawer-body">
        <div class="info-grid">
          <div class="info-item">
            <span>水表编号</span>
            <strong>{{ currentDevice.meter_id }}</strong>
          </div>
          <div class="info-item">
            <span>用户名称</span>
            <strong>{{ currentDevice.username || '—' }}</strong>
          </div>
          <div class="info-item">
            <span>数据情况</span>
            <strong>{{ stateLabels[currentDevice.report_status] || '—' }}</strong>
          </div>
          <div class="info-item">
            <span>{{ freezeStatusLabel }}</span>
            <strong>{{ freezeTagText(currentDevice) }}</strong>
          </div>
          <div class="info-item">
            <span>冻结时间</span>
            <strong>{{ freezeTimeText(currentDevice) }}</strong>
          </div>
          <div class="info-item">
            <span>当前查看方式</span>
            <strong>{{ query.period_type === 'day' ? '按天查看' : '按月查看' }}</strong>
          </div>
        </div>

        <el-table :data="drawerRecords" border size="mini" :header-cell-style="{ background: '#f3f5fa', color: '#56657b' }">
          <el-table-column :label="query.period_type === 'day' ? '日期' : '月份'" prop="period_label" min-width="110" />
          <el-table-column label="用量" min-width="90" align="center">
            <template slot-scope="{ row }">{{ formatFlow(row.flow) }}</template>
          </el-table-column>
          <el-table-column label="起始读数" min-width="100" align="center">
            <template slot-scope="{ row }">{{ formatFlow(row.start_value) }}</template>
          </el-table-column>
          <el-table-column label="结束读数" min-width="100" align="center">
            <template slot-scope="{ row }">{{ formatFlow(row.end_value) }}</template>
          </el-table-column>
          <el-table-column label="状态说明" prop="display_status" min-width="120" show-overflow-tooltip />
        </el-table>

        <div class="api-tip">
          这里展示的是该水表在当前查询范围内，根据{{ query.period_type === 'day' ? '日冻结数据' : '月冻结数据' }}计算出的详细结果，仅用于查询和分析，不作为结账依据。
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { dataConversionUtil } from '@/utils/data2Excel'

function pad (n) {
  return String(n).padStart(2, '0')
}

function formatYMD (date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

function formatYM (date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}`
}

function addDays (date, days) {
  const d = new Date(date.getTime())
  d.setDate(d.getDate() + days)
  return d
}

function makeRecord (label, flow, quality = 'valid_frozen_cycle', display = '正常', start = null, end = null) {
  return {
    period_label: label,
    period_type: label.length === 7 ? 'month' : 'day',
    flow,
    start_value: start,
    end_value: end,
    quality,
    display_status: display
  }
}

function buildDefaultDayRange () {
  const end = addDays(new Date(), -1)
  const start = addDays(end, -6)
  return [formatYMD(start), formatYMD(end)]
}

function buildDefaultMonthRange () {
  const now = new Date()
  const prev = new Date(now.getFullYear(), now.getMonth() - 1, 1)
  const ym = formatYM(prev)
  return [ym, ym]
}

function buildDayLabels (start, end) {
  if (!start || !end) return []
  const labels = []
  let cur = new Date(start.replace(/-/g, '/'))
  const last = new Date(end.replace(/-/g, '/'))
  while (cur <= last) {
    labels.push(formatYMD(cur))
    cur = addDays(cur, 1)
  }
  return labels
}

function buildMonthLabels (start, end) {
  if (!start || !end) return []
  const labels = []
  const [sy, sm] = start.split('-').map(Number)
  const [ey, em] = end.split('-').map(Number)
  let y = sy
  let m = sm
  while (y < ey || (y === ey && m <= em)) {
    labels.push(`${y}-${pad(m)}`)
    m += 1
    if (m > 12) {
      m = 1
      y += 1
    }
  }
  return labels
}

export default {
  name: 'UsageStatistics',
  data () {
    
    const dayRange = buildDefaultDayRange()
    const monthRange = buildDefaultMonthRange()
    return {
      xlspagesize: null,
      drawerSize: '760px',
      isMobile: false,
      loading: false,
      exporting: false,
      projectName: '',
      dayRange,
      monthRange,
      periodLabels: buildDayLabels(dayRange[0], dayRange[1]),
      tableData: [],
      total: 0,
      communities: [],
      buildings: [],
      units: [],
      rooms: [],
      drawerVisible: false,
      currentDevice: null,
      query: {
        token: null,
        period_type: 'day',
        meter_id: '',
        username: '',
        community_id: null,
        building_id: null,
        unit_id: null,
        room_id: null,
        data_status: 'all',
        freeze_status: 'all',
        pagenum: 1,
        pagesize: 30,
        start_date: dayRange[0],
        end_date: dayRange[1],
        start_month: monthRange[0],
        end_month: monthRange[1]
      },
      dataStatusOptions: [
        { value: 'all', label: '全部' },
        { value: 'normal', label: '正常' },
        { value: 'missing', label: '缺少数据' },
        { value: 'abnormal', label: '数据异常' },
        { value: 'recalling', label: '正在补取' },
        { value: 'waiting', label: '等待生成' },
        { value: 'not_enabled', label: '未启用' },
        { value: 'unknown', label: '待确认' }
      ],
      freezeStatusOptions: [
        { value: 'all', label: '全部' },
        { value: 'enabled', label: '已启用' },
        { value: 'disabled', label: '未启用' },
        { value: 'unknown', label: '待确认' }
      ],
      stateLabels: {
        normal: '正常',
        missing: '缺少数据',
        abnormal: '数据异常',
        recalling: '正在补取',
        waiting: '等待生成',
        not_enabled: '未启用',
        unknown: '待确认'
      },
      dayPickerOptions: {
        disabledDate (time) {
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          return time.getTime() >= today.getTime()
        }
      },
      monthPickerOptions: {
        disabledDate (time) {
          const now = new Date()
          const cur = new Date(now.getFullYear(), now.getMonth(), 1)
          return time.getTime() >= cur.getTime()
        }
      },
      headerCellStyle: {
        background: 'linear-gradient(90deg, #7c5df0, #8d70f2)',
        color: '#fff',
        fontWeight: '500',
        textAlign: 'center'
      },
      tableMaxHeight: 520
    }
  },
  computed: {
    freezeStatusLabel () {
      return this.query.period_type === 'day' ? '日冻结功能状态' : '月冻结功能状态'
    },
    drawerTitle () {
      return this.currentDevice ? `水表明细 · ${this.currentDevice.meter_id}` : '设备周期明细'
    },
    drawerRecords () {
      if (!this.currentDevice) return []
      return this.periodLabels.map(label => this.getPeriodRecord(this.currentDevice, label))
    }
  },
  watch: {
    dayRange (val) {
      if (val && val.length === 2) {
        this.query.start_date = val[0]
        this.query.end_date = val[1]
      }
    },
    monthRange (val) {
      if (val && val.length === 2) {
        this.query.start_month = val[0]
        this.query.end_month = val[1]
      }
    }
  },
  created () {
    const goods = this.$store.state.print.goodsForeNo || {}
    this.query.token = goods.token
    this.projectName = goods.project_title || goods.project_name || goods.username || '当前项目'
    this.loadCommunities()
    this.fetchList()
  },
  mounted () {
    this.updateTableHeight()
    window.addEventListener('resize', this.updateTableHeight)
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateTableHeight)
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    freezeCapability (row) {
  return row.freeze_capability ||
  (this.query.period_type === 'day'
    ? row.freeze_capability_day
    : row.freeze_capability_month) ||
  {}
},
// 新增：冻结时间展示文案
// 按天：只显示 freeze_time
// 按月：每月{freeze_day}号 {freeze_time}
freezeTimeText (row) {
  const cap = this.freezeCapability(row) || {}
  const time = cap.freeze_time

  // 按月查看才拼接 freeze_day
  if (this.query.period_type === 'month') {
    // 优先取 freeze_capability 里的 freeze_day，兼容直接挂在行数据上的 freeze_day
    const rawDay = cap.freeze_day != null && cap.freeze_day !== ''
      ? cap.freeze_day
      : (row.freeze_day != null && row.freeze_day !== '' ? row.freeze_day : null)

    if (rawDay != null) {
      // '01' -> 1，纯数字则原样
      const num = Number(rawDay)
      const dayText = Number.isNaN(num) ? rawDay : num
      return time ? `每月${dayText}日 ${time}` : `每月${dayText}日`
    }

    return time || '待确认'
  }

  // 按天查看只显示时间
  return time || '待确认'
},
    checkMobile () {
    this.isMobile = window.innerWidth <= 768
    this.drawerSize = this.isMobile ? '100%' : '760px'
  },
    updateTableHeight () {
      this.tableMaxHeight = Math.max(360, window.innerHeight - 450)
    },
    switchPeriod (type) {
      if (this.query.period_type === type) return
      this.query.period_type = type
      this.query.pagenum = 1
      this.fetchList()
    },
    buildParams () {
      const params = {
        token: this.query.token,
        period_type: this.query.period_type,
        meter_id: this.query.meter_id || undefined,
        username: this.query.username || undefined,
        community_id: this.query.community_id || undefined,
        building_id: this.query.building_id || undefined,
        unit_id: this.query.unit_id || undefined,
        room_id: this.query.room_id || undefined,
        data_status: this.query.data_status,
        freeze_status: this.query.freeze_status,
        pagenum: this.query.pagenum,
        pagesize: this.query.pagesize
      }
      if (this.query.period_type === 'day') {
        params.start_date = this.query.start_date
        params.end_date = this.query.end_date
      } else {
        params.start_month = this.query.start_month
        params.end_month = this.query.end_month
      }
      return params
    },
    syncPeriodLabels () {
      if (this.query.period_type === 'day') {
        this.periodLabels = buildDayLabels(this.query.start_date, this.query.end_date)
      } else {
        this.periodLabels = buildMonthLabels(this.query.start_month, this.query.end_month)
      }
    },
    handleQuery () {
      this.query.pagenum = 1
      this.fetchList()
    },
    handleExport () {
      if (this.query.period_type === 'day') {
        if (!this.query.start_date || !this.query.end_date) {
          this.$message.warning('请选择日期范围')
          return
        }
      } else if (!this.query.start_month || !this.query.end_month) {
        this.$message.warning('请选择月份范围')
        return
      }
      this.exporting = true
      const loading = this.$loading({
        lock: true,
        text: '正在按查询条件导出...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.fetchAllForExport().then(({ list, labels }) => {
        if (!list.length) {
          this.$message.warning('没有可导出的数据')
          return
        }
        const periodLabels = (labels && labels.length)
          ? labels
          : (this.query.period_type === 'day'
            ? buildDayLabels(this.query.start_date, this.query.end_date)
            : buildMonthLabels(this.query.start_month, this.query.end_month))
        const tableHeader = [[
          '水表编号',
          '用户名称',
          '位置',
          this.freezeStatusLabel,
          '数据情况',
          '已统计用量',
          ...periodLabels
        ]]
        const dataList = list.map(row => ([
          row.meter_id || '',
          row.username || '',
          this.exportLocation(row.location),
          this.freezeTagText(row),
          this.stateLabels[row.report_status] || row.report_status || '',
          this.sumKnown(row, periodLabels),
          ...periodLabels.map(label => this.exportFlowCell(row, label))
        ]))
        const range = this.query.period_type === 'day'
          ? `${this.query.start_date}_${this.query.end_date}`
          : `${this.query.start_month}_${this.query.end_month}`
        const mode = this.query.period_type === 'day' ? '按天' : '按月'
        dataConversionUtil.dataToExcel(`用量统计_${mode}_${range}`, tableHeader, dataList)
        this.$message.success('导出成功')
      }).catch(err => {
        this.$message.error((err && err.message) || '导出失败，请稍后重试')
      }).finally(() => {
        this.exporting = false
        loading.close()
      })
    },
    fetchAllForExport () {
      const pageSize = this.xlspagesize
      const base = this.buildParams()
      const all = []
      let page = 1
      let total = Infinity
      let labels = null
      const loadNext = () => {
        return this.$api.usageStatistics.meterUsageReport({
          ...base,
          pagenum: page,
          pagesize: pageSize
        }).then(res => {
          if (!(res && res.data && res.data.status === 'success')) {
            return Promise.reject(new Error((res && res.data && res.data.message) || '查询失败'))
          }
          const parsed = this.parseReportPayload(res.data)
          if (parsed.labels && parsed.labels.length) labels = parsed.labels
          total = parsed.total
          all.push(...parsed.list)
          if (!parsed.list.length || parsed.list.length < pageSize || all.length >= total || page >= 500) {
            return {
              list: all.map(item => this.normalizeDevice(item)),
              labels
            }
          }
          page += 1
          return loadNext()
        })
      }
      return loadNext()
    },
    handleReset () {
      const dayRange = buildDefaultDayRange()
      const monthRange = buildDefaultMonthRange()
      this.dayRange = dayRange
      this.monthRange = monthRange
      this.query = {
        ...this.query,
        period_type: 'day',
        meter_id: '',
        username: '',
        community_id: null,
        building_id: null,
        unit_id: null,
        room_id: null,
        data_status: 'all',
        freeze_status: 'all',
        pagenum: 1,
        pagesize: 30,
        start_date: dayRange[0],
        end_date: dayRange[1],
        start_month: monthRange[0],
        end_month: monthRange[1]
      }
      this.buildings = []
      this.units = []
      this.rooms = []
      this.fetchList()
    },
    handleSizeChange (size) {
      this.query.pagesize = size
      this.query.pagenum = 1
      this.fetchList()
    },
    handleCurrentChange (page) {
      this.query.pagenum = page
      this.fetchList()
    },
    fetchList () {
      this.syncPeriodLabels()
      this.loading = true
      this.$api.usageStatistics.meterUsageReport(this.buildParams()).then(res => {
        if (res && res.data && res.data.status === 'success') {
          this.xlspagesize = res.data.pagesize
          this.applyResponse(res.data)
        } else {
          this.$message.error((res && res.data && res.data.message) || '查询失败')
          this.tableData = []
          this.total = 0
        }
      }).catch(() => {
        // 接口不可用时使用原型结构 mock，保证页面可联调展示
        // this.applyMockData()
        this.$message.error('接口请求失败，请稍后重试')
        this.tableData = []
        this.total = 0
      }).finally(() => {
        this.loading = false
      })
    },
    parseReportPayload (payload) {
      const data = payload.data
      let list = []
      let labels = null
      let total = 0

      if (Array.isArray(data)) {
        list = data
        total = payload.total != null ? payload.total : data.length
      } else if (data && typeof data === 'object') {
        list = data.devices || data.list || data.rows || []
        labels = data.period_labels || data.labels || null
        total = data.total != null ? data.total : (payload.total != null ? payload.total : list.length)
      }

      return { list, labels, total: Number(total) || list.length }
    },
    applyResponse (payload) {
      const { list, labels, total } = this.parseReportPayload(payload)

      if (labels && labels.length) {
        this.periodLabels = labels
      }

      this.tableData = list.map(item => this.normalizeDevice(item))
      this.total = total || this.tableData.length
    },
    normalizeDevice (item) {
      const periodType = this.query.period_type
      let periodMap = item[periodType]
      if (!periodMap && Array.isArray(item.records)) {
        periodMap = {}
        item.records.forEach(r => {
          const key = r.period_label || r.date || r.month
          if (key) periodMap[key] = r
        })
      }
      if (!periodMap && item.periods && typeof item.periods === 'object') {
        periodMap = item.periods
      }
      return {
        ...item,
        [periodType]: periodMap || {}
      }
    },
    // applyMockData () {
    //   const labels = this.periodLabels
    //   const devices = this.getMockDevices(labels)
    //   let filtered = devices

    //   if (this.query.meter_id) {
    //     const meter = String(this.query.meter_id).padStart(12, '0')
    //     filtered = filtered.filter(d => d.meter_id === meter || d.meter_id.includes(this.query.meter_id))
    //   }
    //   if (this.query.username) {
    //     const name = this.query.username.toLowerCase()
    //     filtered = filtered.filter(d => (d.username || '').toLowerCase().includes(name))
    //   }
    //   if (this.query.data_status !== 'all') {
    //     filtered = filtered.filter(d => d.report_status === this.query.data_status)
    //   }
    //   if (this.query.freeze_status !== 'all') {
    //     filtered = filtered.filter(d => {
    //       const enabled = this.freezeEnabled(d)
    //       if (this.query.freeze_status === 'enabled') return enabled === true
    //       if (this.query.freeze_status === 'disabled') return enabled === false
    //       return enabled == null
    //     })
    //   }

    //   this.total = filtered.length
    //   const start = (this.query.pagenum - 1) * this.query.pagesize
    //   this.tableData = filtered.slice(start, start + this.query.pagesize)
    // },
    // getMockDevices (labels) {
    //   const periodType = this.query.period_type
    //   const makeDayMap = (flows) => {
    //     const map = {}
    //     labels.forEach((label, idx) => {
    //       const item = flows[idx] || { flow: null, quality: 'not_collected', display: '尚未采集' }
    //       map[label] = makeRecord(label, item.flow, item.quality, item.display, item.start, item.end)
    //     })
    //     return map
    //   }

    //   const base = [
    //     // {
    //     //   meter_id: '352608130001',
    //     //   username: '水厂300大表',
    //     //   location: { community: '新和县测试区', building: '水厂', unit: '总表', room: '总表' },
    //     //   freeze_enabled_day: true,
    //     //   freeze_enabled_month: null,
    //     //   freeze_capability_day: { enabled: true, freeze_time: null },
    //     //   freeze_capability_month: { enabled: null, freeze_time: null },
    //     //   report_status: 'missing',
    //     //   flows: [
    //     //     { flow: null, quality: 'not_collected', display: '冻结缺失' },
    //     //     { flow: null, quality: 'not_collected', display: '冻结缺失' },
    //     //     { flow: null, quality: 'not_enabled', display: '未开启冻结' },
    //     //     { flow: '4890.6', quality: 'valid_frozen_cycle', display: '正常', start: '15238.0', end: '20128.6' },
    //     //     { flow: '5791.7', quality: 'valid_frozen_cycle', display: '正常', start: '20128.6', end: '25920.3' },
    //     //     { flow: '6200.2', quality: 'valid_frozen_cycle', display: '正常', start: '25920.3', end: '32120.5' },
    //     //     { flow: '6455.1', quality: 'valid_frozen_cycle', display: '正常', start: '32120.5', end: '38575.6' }
    //     //   ],
    //     //   monthFlow: { flow: null, quality: 'missing_boundary', display: '冻结缺失' }
    //     // },
    //     // {
    //     //   meter_id: '982605290001',
    //     //   username: '冻结测试表1',
    //     //   location: { community: '新和县测试区', building: '1栋', unit: '1单元', room: '101' },
    //     //   freeze_enabled_day: true,
    //     //   freeze_enabled_month: true,
    //     //   freeze_capability_day: { enabled: true, freeze_time: '08:00:00' },
    //     //   freeze_capability_month: { enabled: true, freeze_time: null },
    //     //   report_status: 'normal',
    //     //   flows: [
    //     //     { flow: '44.1', quality: 'valid_frozen_cycle', display: '正常', start: '11999.3', end: '12043.4' },
    //     //     { flow: '44.0', quality: 'valid_frozen_cycle', display: '正常', start: '12043.4', end: '12087.4' },
    //     //     { flow: '44.0', quality: 'valid_frozen_cycle', display: '正常', start: '12087.4', end: '12131.4' },
    //     //     { flow: '44.1', quality: 'valid_frozen_cycle', display: '正常', start: '12131.4', end: '12175.5' },
    //     //     { flow: '38.4', quality: 'valid_frozen_cycle', display: '正常', start: '12175.5', end: '12213.9' },
    //     //     { flow: '43.9', quality: 'valid_frozen_cycle', display: '正常', start: '12213.9', end: '12257.8' },
    //     //     { flow: '43.7', quality: 'valid_frozen_cycle', display: '正常', start: '12257.8', end: '12301.5' }
    //     //   ],
    //     //   monthFlow: { flow: '1365.1', quality: 'valid_frozen_cycle', display: '正常', start: '10590.2', end: '11955.3' }
    //     // },
    //     // {
    //     //   meter_id: '982606040001',
    //     //   username: '冻结测试表2',
    //     //   location: { community: '新和县测试区', building: '1栋', unit: '1单元', room: '102' },
    //     //   freeze_enabled_day: true,
    //     //   freeze_enabled_month: true,
    //     //   freeze_capability_day: { enabled: true, freeze_time: '08:00:00' },
    //     //   freeze_capability_month: { enabled: true, freeze_time: null },
    //     //   report_status: 'normal',
    //     //   flows: [
    //     //     { flow: '47.2', quality: 'valid_frozen_cycle', display: '正常', start: '12584.7', end: '12631.9' },
    //     //     { flow: '47.2', quality: 'valid_frozen_cycle', display: '正常', start: '12631.9', end: '12679.1' },
    //     //     { flow: '47.3', quality: 'valid_frozen_cycle', display: '正常', start: '12679.1', end: '12726.4' },
    //     //     { flow: '47.2', quality: 'valid_frozen_cycle', display: '正常', start: '12726.4', end: '12773.6' },
    //     //     { flow: '41.2', quality: 'valid_frozen_cycle', display: '正常', start: '12773.6', end: '12814.8' },
    //     //     { flow: '47.2', quality: 'valid_frozen_cycle', display: '正常', start: '12814.8', end: '12862.0' },
    //     //     { flow: '46.5', quality: 'valid_frozen_cycle', display: '正常', start: '12862.0', end: '12908.5' }
    //     //   ],
    //     //   monthFlow: { flow: '1475.8', quality: 'valid_frozen_cycle', display: '正常', start: '11061.8', end: '12537.6' }
    //     // },
    //     // {
    //     //   meter_id: '982606160001',
    //     //   username: '冻结测试表3',
    //     //   location: { community: '新和县测试区', building: '2栋', unit: '1单元', room: '201' },
    //     //   freeze_enabled_day: true,
    //     //   freeze_enabled_month: true,
    //     //   freeze_capability_day: { enabled: true, freeze_time: '08:00:00' },
    //     //   freeze_capability_month: { enabled: true, freeze_time: null },
    //     //   report_status: 'normal',
    //     //   flows: [
    //     //     { flow: '40.95', quality: 'valid_frozen_cycle', display: '正常', start: '3119.69', end: '3160.64' },
    //     //     { flow: '40.92', quality: 'valid_frozen_cycle', display: '正常', start: '3160.64', end: '3201.56' },
    //     //     { flow: '40.92', quality: 'valid_frozen_cycle', display: '正常', start: '3201.56', end: '3242.48' },
    //     //     { flow: '40.91', quality: 'valid_frozen_cycle', display: '正常', start: '3242.48', end: '3283.39' },
    //     //     { flow: '35.65', quality: 'valid_frozen_cycle', display: '正常', start: '3283.39', end: '3319.04' },
    //     //     { flow: '40.82', quality: 'valid_frozen_cycle', display: '正常', start: '3319.04', end: '3359.86' },
    //     //     { flow: '40.41', quality: 'valid_frozen_cycle', display: '正常', start: '3359.86', end: '3400.27' }
    //     //   ],
    //     //   monthFlow: { flow: '1276.74', quality: 'valid_frozen_cycle', display: '正常', start: '1802.02', end: '3078.76' }
    //     // },
    //     // {
    //     //   meter_id: '982607080001',
    //     //   username: '冻结测试表4',
    //     //   location: { community: '新和县测试区', building: '2栋', unit: '1单元', room: '202' },
    //     //   freeze_enabled_day: true,
    //     //   freeze_enabled_month: true,
    //     //   freeze_capability_day: { enabled: true, freeze_time: '08:00:00' },
    //     //   freeze_capability_month: { enabled: true, freeze_time: null },
    //     //   report_status: 'normal',
    //     //   flows: [
    //     //     { flow: '42.1', quality: 'valid_frozen_cycle', display: '正常', start: '11822.7', end: '11864.8' },
    //     //     { flow: '42.1', quality: 'valid_frozen_cycle', display: '正常', start: '11864.8', end: '11906.9' },
    //     //     { flow: '42.1', quality: 'valid_frozen_cycle', display: '正常', start: '11906.9', end: '11949.0' },
    //     //     { flow: '42.1', quality: 'valid_frozen_cycle', display: '正常', start: '11949.0', end: '11991.1' },
    //     //     { flow: '36.7', quality: 'valid_frozen_cycle', display: '正常', start: '11991.1', end: '12027.8' },
    //     //     { flow: '41.9', quality: 'valid_frozen_cycle', display: '正常', start: '12027.8', end: '12069.7' },
    //     //     { flow: '41.6', quality: 'valid_frozen_cycle', display: '正常', start: '12069.7', end: '12111.3' }
    //     //   ],
    //     //   monthFlow: { flow: '1313.8', quality: 'valid_frozen_cycle', display: '正常', start: '10466.8', end: '11780.6' }
    //     // }
    //   ]

    //   return base.map(item => {
    //     const dayMap = makeDayMap(item.flows)
    //     const monthMap = {}
    //     labels.forEach(label => {
    //       monthMap[label] = makeRecord(
    //         label,
    //         item.monthFlow.flow,
    //         item.monthFlow.quality,
    //         item.monthFlow.display,
    //         item.monthFlow.start,
    //         item.monthFlow.end
    //       )
    //     })
    //     return {
    //       meter_id: item.meter_id,
    //       username: item.username,
    //       location: item.location,
    //       freeze_enabled_day: item.freeze_enabled_day,
    //       freeze_enabled_month: item.freeze_enabled_month,
    //       freeze_capability_day: item.freeze_capability_day,
    //       freeze_capability_month: item.freeze_capability_month,
    //       report_status: item.report_status,
    //       day: dayMap,
    //       month: periodType === 'month' ? monthMap : { [labels[0] || '2026-08']: makeRecord(labels[0] || '2026-08', item.monthFlow.flow, item.monthFlow.quality, item.monthFlow.display, item.monthFlow.start, item.monthFlow.end) }
    //     }
    //   })
    // },
    loadCommunities () {
      this.$api.userProfile.communities({ token: this.query.token }).then(res => {
        if (res && res.data && res.data.data) {
          this.communities = res.data.data
        }
      }).catch(() => {})
    },
    onCommunityChange (val) {
      this.query.building_id = null
      this.query.unit_id = null
      this.query.room_id = null
      this.buildings = []
      this.units = []
      this.rooms = []
      if (!val) return
      this.$api.userProfile.buildings({ token: this.query.token, community_id: val }).then(res => {
        this.buildings = (res && res.data && res.data.data) || []
      })
    },
    onBuildingChange (val) {
      this.query.unit_id = null
      this.query.room_id = null
      this.units = []
      this.rooms = []
      if (!val) return
      this.$api.userProfile.units({ token: this.query.token, building_id: val }).then(res => {
        this.units = (res && res.data && res.data.data) || []
      })
    },
    onUnitChange (val) {
      this.query.room_id = null
      this.rooms = []
      if (!val) return
      this.$api.userProfile.rooms({ token: this.query.token, unit_id: val }).then(res => {
        this.rooms = (res && res.data && res.data.data) || []
      })
    },
    formatLocation (location) {
      if (!location) return '—'
      if (typeof location === 'string') return location || '—'
      return [location.community, location.building, location.unit, location.room].filter(Boolean).join(' / ') || '—'
    },
    exportLocation (location) {
      const text = this.formatLocation(location)
      return text === '—' ? '' : text
    },
    freezeEnabled (row) {
      const val = row.freeze_enabled
      if (val === true || val === false) return val
      // 兼容原型 mock 的旧字段（可选保留）
      const legacy = this.query.period_type === 'day'
        ? row.freeze_enabled_day
        : row.freeze_enabled_month
      if (legacy === true || legacy === false) return legacy
      return null
    },
    freezeCapability (row) {
      return row.freeze_capability ||
      (this.query.period_type === 'day'
        ? row.freeze_capability_day
        : row.freeze_capability_month) ||
      {}
    },
    freezeTagText (row) {
      const enabled = this.freezeEnabled(row)
      if (enabled === true) return '已启用'
      if (enabled === false) return '未启用'
      return '待确认'
    },
    freezeTagClass (row) {
      const enabled = this.freezeEnabled(row)
      if (enabled === true) return 'enabled'
      if (enabled === false) return 'disabled'
      return 'unknown'
    },
    getPeriodRecord (row, label) {
      const map = row[this.query.period_type] || {}
      return map[label] || makeRecord(label, null, 'not_collected', '尚未采集')
    },
    formatFlow (val) {
      return val === null || val === undefined || val === '' ? '—' : val
    },
    exportFlowCell (row, label) {
      const record = this.getPeriodRecord(row, label)
      if (record.flow !== null && record.flow !== undefined && record.flow !== '') return record.flow
      return record.display_status && record.display_status !== '—' ? record.display_status : ''
    },
    sumKnown (row, labels) {
      const cols = labels || this.periodLabels
      const vals = cols
        .map(label => this.getPeriodRecord(row, label).flow)
        .filter(v => v !== null && v !== undefined && v !== '')
        .map(Number)
        .filter(n => !Number.isNaN(n))
      if (!vals.length) return '—'
      return vals.reduce((a, b) => a + b, 0).toFixed(2)
    },
    openDrawer (row) {
      this.currentDevice = row
      this.drawerVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
.usage-page {
  color: #26364d;
  background: #fff;
  min-height: 100%;
}

.Gnv {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  background-color: #ecf0f1;
  padding-left: 18px;
  box-sizing: border-box;
  .el-breadcrumb {
    display: flex;
    align-items: center;
    margin-left: 20px;
    .yai{
      width: 5px;
      height: 17px;
      background-color: #987AFF;
      margin-right: 18px;
    }
    ::v-deep .el-breadcrumb__item{
      margin-left: 0px;
      .el-breadcrumb__inner.is-link{
        font-weight: 100;
        color: #656d92;
  }
    }
  }
}

.page-body {
  padding: 16px 20px 28px;
}

.page-head {
  margin-bottom: 12px;

  h1 {
    margin: 0 0 6px;
    font-size: 22px;
    color: #26364d;
  }

  p {
    margin: 0;
    color: #8491a6;
    font-size: 13px;
  }
}

.filter-card,
.table-card,
.note-card {
  border: 1px solid #e5e9f2;
  border-radius: 7px;
  margin-bottom: 12px;
  box-shadow: 0 4px 16px rgba(29, 50, 84, 0.06);
}

.filter-form {
  ::v-deep .el-form-item__label {
    padding: 0;
    line-height: 1.2;
    color: #617089;
    font-size: 12px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 10px;
  }
}

.period-switch {
  display: flex;
  height: 32px;

  button {
    flex: 1;
    border: 1px solid #dce2ec;
    background: #fff;
    color: #63728a;
    cursor: pointer;
    outline: none;

    &:first-child {
      border-radius: 4px 0 0 4px;
    }

    &:last-child {
      border-radius: 0 4px 4px 0;
      margin-left: -1px;
    }

    &.active {
      color: #fff;
      background: #6f4cff;
      border-color: #6f4cff;
      z-index: 1;
    }
  }
}

.filter-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  min-height: 32px;
}

.table-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.table-title {
  font-size: 16px;
  font-weight: 600;
  color: #26364d;
}

.meta {
  color: #8a96a8;
  font-size: 12px;
}

.meter-cell {
  cursor: pointer;
  line-height: 1.3;
}

.meter-link {
  color: #4e8cff;
}

.meter-tip {
  display: block;
  font-size: 11px;
  color: #9aa5b5;
  margin-top: 2px;
}

.period-cell {
  line-height: 1.3;

  .flow {
    display: block;
    font-weight: 600;
    color: #304460;
  }

  .sub {
    display: block;
    font-size: 11px;
    color: #98a2b1;
    margin-top: 3px;
  }

  &.missing .flow {
    color: #98a2b1;
  }
}

.known-sum {
  font-weight: 700;
  color: #4f5f78;
}

.tag {
  display: inline-block;
  line-height: 22px;
  min-width: 54px;
  padding: 0 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
}

.tag.normal,
.tag.enabled {
  color: #0b9a6e;
  background: #eaf9f3;
}

.tag.missing,
.tag.not_enabled,
.tag.disabled {
  color: #d98915;
  background: #fff5e5;
}

.tag.abnormal {
  color: #d94a55;
  background: #ffedef;
}

.tag.recalling {
  color: #7750d3;
  background: #f1ecff;
}

.tag.waiting {
  color: #3d74c5;
  background: #edf5ff;
}

.tag.unknown {
  color: #7e8999;
  background: #f0f2f5;
}

.table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding-top: 12px;
  flex-wrap: wrap;
}

.footnote {
  color: #75839a;
  font-size: 12px;
}

.note-card {
  p {
    margin: 6px 0;
    color: #6f7d91;
    line-height: 1.8;
    font-size: 13px;
  }
}

.drawer-body {
  padding: 0 20px 24px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-bottom: 16px;
}

.info-item {
  background: #f8f9fc;
  border: 1px solid #e5e9f2;
  border-radius: 5px;
  padding: 9px 10px;

  span {
    display: block;
    color: #8b96a8;
    font-size: 11px;
    margin-bottom: 3px;
  }

  strong {
    color: #26364d;
    font-size: 13px;
  }
}

.api-tip {
  margin-top: 12px;
  padding: 10px 12px;
  background: #f5f9ff;
  border: 1px solid #dae7ff;
  border-radius: 5px;
  color: #58709a;
  font-size: 12px;
  line-height: 1.7;
}

@media (max-width: 768px) {
  .page-body {
    padding: 12px 10px 20px;
  }

  .Gnv {
    display: none;
  }

  /* ========== 新增：抽屉内部适配 ========== */
  ::v-deep .usage-drawer {
    /* 抽屉头部紧凑一点 */
    .el-drawer__header {
      padding: 12px 15px;
      margin-bottom: 10px;
      font-size: 15px;
    }
    
    /* 抽屉内容区 padding 减小 */
    .el-drawer__body {
      padding: 10px;
      overflow-x: hidden; /* 防止外层横向溢出 */
    }

    /* 信息网格改为单列，避免手机端被挤压 */
    .info-grid {
      grid-template-columns: 1fr !important;
      gap: 8px;
      margin-bottom: 12px;
    }

    .info-item {
      padding: 6px 8px;
    }

    .drawer-body {
      padding: 0 10px 20px;
    }

    .api-tip {
      margin-top: 8px;
      padding: 8px;
      font-size: 11px;
      line-height: 1.5;
    }

    /* 抽屉内表格的移动端适配 */
    .el-table {
      font-size: 12px;
      
      /* 开启表格内部横向滚动 */
      .el-table__body-wrapper {
        overflow-x: auto !important;
        -webkit-overflow-scrolling: touch;
      }
    }
  }
  /* ==================================== */
  
  .info-grid {
    /* 原有的单列设置保留，以防万一 */
    grid-template-columns: 1fr;
  }

  .table-footer {
    flex-direction: column;
    align-items: flex-start;
  }
}

</style>
